import { render, staticRenderFns } from "./CompanyBack.vue?vue&type=template&id=2e98df4b&scoped=true&"
import script from "./CompanyBack.vue?vue&type=script&lang=js&"
export * from "./CompanyBack.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBack.vue?vue&type=style&index=0&id=2e98df4b&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=2e98df4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98df4b",
  null
  
)

export default component.exports